'use client';

import type { APlusQuery, PriceCurrency } from '@packages/gql/generated/shopping/graphql';

import { useSetAtom } from 'jotai';
import { useIntl } from 'react-intl';

import { selectedServices } from '@packages/modules/src/atoms';
import { APlus } from '@packages/modules/src/APlus/APlus';
import type { APlusCluster, APlusData } from '@packages/modules/src/APlus/types';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { TipBadge } from '../TipBadge/TipBadge.client';

type ClusteredProps = {
  data: APlusQuery['aplus'];
  currency: PriceCurrency;
};

export const Clustered = ({ data, currency }: ClusteredProps) => {
  const { formatMessage } = useIntl();
  const setAtomSelected = useSetAtom(selectedServices);

  if (!data || !data.clusters || data.clusters.length === 0) return null;

  const clusteredServicesData: APlusCluster = [];

  data.clusters.forEach((cluster) => {
    if (cluster != null) {
      clusteredServicesData.push({
        label: cluster.label,
        items: cluster.services.map((service) => ({
          uuid: service.uuid,
          orderId: service.orderId,
          name: service.name,
          price: service.price,
          serviceIcon: service.serviceIcon,
          serviceLayerId: service.serviceLayerId,
          clusterLabel: cluster.label,
          free: !!service.gratis,
          preselected: service.preselected,
          mandatory: service.mandatory,
        })),
      });
    }
  });

  if (clusteredServicesData.length === 0) {
    return null;
  }

  const handleAtom = (atomData: APlusData) => {
    setAtomSelected(atomData);
  };

  return (
    <Card>
      <CardHeader hasDivider>
        <TipBadge />
        <div className="text-size-body-base">
          {formatMessage({
            id: 'productAplus.clustered.headline',
            defaultMessage: 'Services jetzt dazu bestellen',
          })}
        </div>
      </CardHeader>
      <CardContent className="pb-2">
        <APlus
          clusteredData={clusteredServicesData}
          onChangeHandler={handleAtom}
          triggerOnChangeHandlerOnInit
          currency={currency}
          layout="Clustered"
        />
      </CardContent>
    </Card>
  );
};
